import { ɵɵdefineInjectable, ɵɵinject, Injectable } from '@angular/core';
import { BaseApiService } from '@prv/apis';
import { NexaConfigurationService } from '@nexa/configuration';
import { HttpClient } from '@angular/common/http';

/*
Servicio encargado de interactuar con el MS de TypePhone
*/
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from '@nexa/configuration';
class ChannelApiService extends BaseApiService {
    /*
    Crear una nueva instancia de @see type-phone.ApiServices
    */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'platform', 'Channel');
    }
    /**
     * Metodo encargado de consultar todos los registros por codigo de enumeración
     * @param codEnum Codigo de enumeración
     * @param state Estado de activación del registro
     * @returns Retorna un array con la información de los nodos @see NodeDto
     */
    GetChannelByCodEnum(codEnum) {
        return this.getUri(uri => this.httpClient.get(`${uri}/GetChannelByCodEnum/${codEnum}`));
    }
}
ChannelApiService.ɵfac = function ChannelApiService_Factory(t) { return new (t || ChannelApiService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ɵngcc2.NexaConfigurationService)); };
ChannelApiService.ɵprov = ɵɵdefineInjectable({ factory: function ChannelApiService_Factory() { return new ChannelApiService(ɵɵinject(HttpClient), ɵɵinject(NexaConfigurationService)); }, token: ChannelApiService, providedIn: "root" });
ChannelApiService.ctorParameters = () => [
    { type: HttpClient },
    { type: NexaConfigurationService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ChannelApiService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ɵngcc2.NexaConfigurationService }]; }, null); })();

/*
Servicio encargado de interactuar con el MS de TypePhone
*/
class ModalityApiService extends BaseApiService {
    /*
    Crear una nueva instancia de @see type-phone.ApiServices
    */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'platform', 'Modality');
    }
}
ModalityApiService.ɵfac = function ModalityApiService_Factory(t) { return new (t || ModalityApiService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ɵngcc2.NexaConfigurationService)); };
ModalityApiService.ɵprov = ɵɵdefineInjectable({ factory: function ModalityApiService_Factory() { return new ModalityApiService(ɵɵinject(HttpClient), ɵɵinject(NexaConfigurationService)); }, token: ModalityApiService, providedIn: "root" });
ModalityApiService.ctorParameters = () => [
    { type: HttpClient },
    { type: NexaConfigurationService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalityApiService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ɵngcc2.NexaConfigurationService }]; }, null); })();

/*
Servicio encargado de interactuar con el MS de TypePhone
*/
class ModalityChannelApiService extends BaseApiService {
    /*
    Crear una nueva instancia de @see type-phone.ApiServices
    */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'platform', 'ModalityChannel');
    }
    /**
     * Metodo encargado de consultar todos los registros asociados a una modalidad en específico
     * @param args Objeto encargado de contener las propiedades de idClient, idCampaign y idTypeForm para el filtro
     */
    getByModality(args) {
        const data = Object.assign({ idModality: 1 }, args);
        const parameters = `${data.idModality}`;
        return this.getUri(uri => this.httpClient.get(`${uri}/GetByModality/${parameters}`));
    }
    /**
     * Metodo encargado de consultar todos los registros asociados a una modalidad en específico
     * @param args Objeto encargado de contener las propiedades de idClient, idCampaign y idTypeForm para el filtro
     */
    getByChannel(args) {
        const data = Object.assign({ idChannel: 1 }, args);
        const parameters = `${data.idChannel}`;
        return this.getUri(uri => this.httpClient.get(`${uri}/GetByChannel/${parameters}`));
    }
    /**
     * Metodo encargado de consultar todos los registros asociados a una modalidad en específico
     * @param args Objeto encargado de contener las propiedades de idClient, idCampaign y idTypeForm para el filtro
     */
    getByModalityChannel(args) {
        const data = Object.assign({ idModality: 0, idChannel: 0 }, args);
        const parameters = `${data.idModality}/${data.idChannel}`;
        return this.getUri(uri => this.httpClient.get(`${uri}/GetByModalityChannel/${parameters}`));
    }
}
ModalityChannelApiService.ɵfac = function ModalityChannelApiService_Factory(t) { return new (t || ModalityChannelApiService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ɵngcc2.NexaConfigurationService)); };
ModalityChannelApiService.ɵprov = ɵɵdefineInjectable({ factory: function ModalityChannelApiService_Factory() { return new ModalityChannelApiService(ɵɵinject(HttpClient), ɵɵinject(NexaConfigurationService)); }, token: ModalityChannelApiService, providedIn: "root" });
ModalityChannelApiService.ctorParameters = () => [
    { type: HttpClient },
    { type: NexaConfigurationService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalityChannelApiService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ɵngcc2.NexaConfigurationService }]; }, null); })();

/*
Servicio encargado de interactuar con el MS de TypePhone
*/
class PlatformApiService extends BaseApiService {
    /*
    Crear una nueva instancia de @see type-phone.ApiServices
    */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'platform', 'Platform');
    }
}
PlatformApiService.ɵfac = function PlatformApiService_Factory(t) { return new (t || PlatformApiService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ɵngcc2.NexaConfigurationService)); };
PlatformApiService.ɵprov = ɵɵdefineInjectable({ factory: function PlatformApiService_Factory() { return new PlatformApiService(ɵɵinject(HttpClient), ɵɵinject(NexaConfigurationService)); }, token: PlatformApiService, providedIn: "root" });
PlatformApiService.ctorParameters = () => [
    { type: HttpClient },
    { type: NexaConfigurationService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PlatformApiService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ɵngcc2.NexaConfigurationService }]; }, null); })();

/*
Servicio encargado de interactuar con el MS de TypePhone
*/
class PlatformChannelApiService extends BaseApiService {
    /*
    Crear una nueva instancia de @see type-phone.ApiServices
    */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'platform', 'PlatformChannel');
    }
    /**
     * Metodo encargado de consultar todos los registros asociados a una modalidad en específico
     * @param args Objeto encargado de contener las propiedades de idClient, idCampaign y idTypeForm para el filtro
     */
    getByChannel(args) {
        const data = Object.assign({ idChannel: 1 }, args);
        const parameters = `${data.idChannel}`;
        return this.getUri(uri => this.httpClient.get(`${uri}/GetByChannel/${parameters}`));
    }
    /**
     * Metodo encargado de consultar todos los registros asociados a una modalidad en específico
     * @param args Objeto encargado de contener las propiedades de idClient, idCampaign y idTypeForm para el filtro
     */
    getByPlatform(args) {
        const data = Object.assign({ idPlatform: 1 }, args);
        const parameters = `${data.idPlatform}`;
        return this.getUri(uri => this.httpClient.get(`${uri}/GetByPlatform/${parameters}`));
    }
    /**
     * Metodo encargado de consultar todos los registros asociados a una modalidad en específico
     * @param args Objeto encargado de contener las propiedades de idClient, idCampaign y idTypeForm para el filtro
     */
    getByPlatformChannel(args) {
        const data = Object.assign({ idChannel: 1, idPlatform: 1 }, args);
        const parameters = `${data.idChannel}/${data.idPlatform}`;
        return this.getUri(uri => this.httpClient.get(`${uri}/GetByPlatformChannel/${parameters}`));
    }
}
PlatformChannelApiService.ɵfac = function PlatformChannelApiService_Factory(t) { return new (t || PlatformChannelApiService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ɵngcc2.NexaConfigurationService)); };
PlatformChannelApiService.ɵprov = ɵɵdefineInjectable({ factory: function PlatformChannelApiService_Factory() { return new PlatformChannelApiService(ɵɵinject(HttpClient), ɵɵinject(NexaConfigurationService)); }, token: PlatformChannelApiService, providedIn: "root" });
PlatformChannelApiService.ctorParameters = () => [
    { type: HttpClient },
    { type: NexaConfigurationService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PlatformChannelApiService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ɵngcc2.NexaConfigurationService }]; }, null); })();

/*
 * Public API Surface of platform
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ChannelApiService, ModalityApiService, ModalityChannelApiService, PlatformApiService, PlatformChannelApiService };

